import { LayoutDashboard, Users, Shield } from 'lucide-react';
import type { Permission } from '@/shared/api/types';

export interface NavItem {
  id: string;
  label: string;
  icon: React.ReactNode;
  href: string;
  permission?: Permission;
}

/**
 * Primary navigation (F2.5 · UX-3) — client-centric.
 *
 * Only real, usable destinations appear. Audiences, Campaigns, Tracking,
 * Reports, Integrations, and Data Sources are operated inside a Client
 * (Clients → detail tabs), where they work today. F3 promotes workspace-level
 * versions back to the top level once those experiences are actually built.
 * Shared by Sidebar and MobileNav so the two never drift.
 */
export const NAV_ITEMS: NavItem[] = [
  {
    id: 'overview',
    label: 'nav.overview',
    icon: <LayoutDashboard className="h-5 w-5" />,
    href: '/app/overview',
    permission: 'view:dashboard',
  },
  {
    id: 'clients',
    label: 'nav.clients',
    icon: <Users className="h-5 w-5" />,
    href: '/app/clients',
    permission: 'view:clients',
  },
  {
    id: 'admin',
    label: 'nav.admin',
    icon: <Shield className="h-5 w-5" />,
    href: '/app/admin',
    permission: 'view:admin',
  },
];
